export default __webpack_public_path__ + "4f5a56c437e8d6172fbc5bbd517a9f00.jpg";